import { style } from '@vanilla-extract/css'
import { vars } from '~/styles/theme.css'

export const inlineOnboarding = style({
  display: 'flex',
  flexDirection: 'column',
  gap: 6,
  padding: 12,
  borderRadius: vars.blocks.smallRadius,
  border: `1px solid ${vars.color.mediumLighter}`,
  boxShadow: vars.shadow,
  backgroundColor: vars.color.white,
  maxWidth: 360,
  position: 'relative'
})

export const inlineOnboardingFloating = style({
  display: 'flex',
  alignItems: 'flex-start',
  pointerEvents: 'auto',
  zIndex: 1000
})

export const inlineOnboardingFloatingHidden = style({
  visibility: 'hidden'
})

export const inlineOnboardingFloatingEnd = style({
  alignItems: 'flex-end'
})

export const inlineOnboardingFloatingRight = style({
  flexDirection: 'row-reverse'
})

export const inlineOnboardingFloatingLeft = style({
  flexDirection: 'row'
})

export const inlineOnboardingTitle = style({
  color: vars.color.dark,
  fontSize: vars.font.h5.size,
  fontWeight: vars.font.h5.weight,
  whiteSpace: 'nowrap',
  marginRight: 28
})

export const inlineOnboardingDetails = style({
  color: vars.color.dark,
  fontSize: vars.font.subcontent.size,
  fontWeight: vars.font.subcontent.weight,
  marginBottom: 6
})

export const inlineOnboardingAnchorArrow = style({
  pointerEvents: 'none',
  width: 58,
  marginTop: 6,
  color: vars.color.primary
})

export const inlineOnboardingAnchorArrowRight = style({
  transform: 'rotate(180deg)',
  marginRight: 2
})

export const inlineOnboardingAnchorArrowLeft = style({
  transform: 'scaleY(-1)',
  marginLeft: 2
})

export const inlineOnboardingAnchorArrowEnd = style({
  marginTop: 0,
  marginBottom: 6
})

export const inlineOnboardingAnchorArrowEndRight = style({
  transform: 'scaleX(-1)',
  marginRight: 2
})

export const inlineOnboardingAnchorArrowEndLeft = style({
  marginLeft: 2
})
